module.exports = __webpack_public_path__ + "static/media/5.2ceb4f4d.png";